import type { HTMLAttributes } from "react";

interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {}

export const Skeleton = ({ className = "", ...rest }: SkeletonProps) => {
  return (
    <div
      className={`animate-pulse rounded-md bg-zinc-200 dark:bg-zinc-800 ${className}`}
      {...rest}
    />
  );
};

export const SkeletonCard = () => (
  <div
    data-testid="skeleton-card"
    className="rounded-xl border border-zinc-200 dark:border-zinc-800 p-4 space-y-3"
  >
    <Skeleton className="h-4 w-24" />
    <div className="space-y-2">
      <Skeleton className="h-3 w-full" />
      <Skeleton className="h-3 w-full" />
      <Skeleton className="h-3 w-3/4" />
    </div>
  </div>
);

interface SkeletonListProps {
  count?: number;
}

export const SkeletonList = ({ count = 4 }: SkeletonListProps) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonCard key={i} />
    ))}
  </div>
);
